import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'workflowErrorHandlerMessage',
})
export class WorkflowErrorHandlerMessagePipe implements PipeTransform {
  transform(errors: unknown[]): string[] {
    if (!errors) {
      return [];
    }
    return errors
      .map((error: unknown): string | undefined => {
        if (typeof error === 'string') {
          return error;
        } else if (error && typeof error === 'object' && 'errorMessage' in error) {
          return error.errorMessage as string;
        }
        return error?.toString();
      })
      .filter(Boolean) as string[];
  }
}
